<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Raw Material Purchase
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="Raw Material Purchase"
                outlined
                v-model="form.raw_material_id"
                :items="rawmaterialItems"
                label="Raw Material"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.raw_material_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Raw Material Purchase
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "RawMaterialPurchaseEditPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      rawmaterialItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    //get data for masters
    async getMasters() {
      await axios
        .get(`raw_material_purchases/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.rawmaterials.forEach((rawmaterial) => {
            this.rawmaterialItems.push({
              id: rawmaterial.id,
              text: rawmaterial.name,
              value: rawmaterial.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    //get data (text filed)
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.rawMaterialPurchaseId;
      axios
        .get(`/raw_material_purchases/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(
          `/raw_material_purchases/${this.$route.params.rawMaterialPurchaseId}`,
          this.form
        );
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/raw_material_purchase/${this.form.id}`,
          from_name: "GiftEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/raw-material-purchases");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
